var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions } from '@ngrx/effects';
import * as candidateAction from '../actions/candidate.action';
import { map, switchMap, mergeMap, withLatestFrom, filter } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { isNullOrUndefined } from 'util';
import { CandidateService } from '../../candidate.service';
var CandidateEffect = /** @class */ (function () {
    function CandidateEffect(actions, candidateService, store) {
        var _this = this;
        this.actions = actions;
        this.candidateService = candidateService;
        this.store = store;
        this.getAllCandidates = this.actions.ofType(candidateAction.GET_ALL_CANDIDATES)
            .pipe(switchMap(function () {
            return _this.candidateService.getAllCandidates()
                .map(function (res) { return new candidateAction.GetAllCandidatesSuccess(res); })
                .catch(function (error) { return of(new candidateAction.GetAllCandidatesError(error)); });
        }));
        this.getCandidate = this.actions.ofType(candidateAction.GET_CANDIDATE)
            .pipe(withLatestFrom(
        // select candidates.
        this.store.select(function (state) { return state.candidatesFeature.candidates.entities; }), function (action, candidates) {
            // if no candidates present, proceed for API.
            if (isNullOrUndefined(candidates)) {
                return action;
            }
            else {
                // brands exists in store.
                var candidate = candidates.filter(function (c) { return c.id === action.payload; })[0];
                if (!!candidate) {
                    // if required candidate is present in store, then return;
                    return undefined;
                }
                else {
                    // if required candidate not present in store, then proceed for API.
                    return action;
                }
            }
        }), filter(function (action) { return !!action; }), mergeMap(function (action) {
            return _this.candidateService.getCandidate(action.payload)
                .map(function (res) { return new candidateAction.GetCandidateSuccess(res); })
                .catch(function (error) { return of(new candidateAction.GetCandidateError((error))); });
        }));
        this.deleteCandidate = this.actions.ofType(candidateAction.DELETE_CANDIDATE)
            .pipe(map(function (action) { return action.payload; }), switchMap(function (candidateId) {
            return _this.candidateService.deleteCandidate(candidateId)
                .map(function (r) { return new candidateAction.DeleteCandidateSuccess(); })
                .catch(function (e) { return of(new candidateAction.DeleteCandidateError(e)); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], CandidateEffect.prototype, "getAllCandidates", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], CandidateEffect.prototype, "getCandidate", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], CandidateEffect.prototype, "deleteCandidate", void 0);
    return CandidateEffect;
}());
export { CandidateEffect };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/candidates/store/effects/candidate.effect.ts.pre-build-optimizer.js